<span class="field-view-value">{{formattedTime || '—'}}</span>
